import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getPublicApiKeys } from './api';
import type { PublicApiKey } from './types';

const PUBLIC_API_KEY = 'PUBLIC_API_KEY';

export const usePublicApiKey = (): UseQueryResult<PublicApiKey[]> => {
  return useQuery([PUBLIC_API_KEY], getPublicApiKeys, { staleTime: 0 });
};
